import script from "./AssertionRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssertionRow.vue?vue&type=script&lang=ts&setup=true"

import "./AssertionRow.vue?vue&type=style&index=0&id=12482636&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12482636"]])

export default __exports__